(function ($) {
  $(document).ready(function () {
    if ($.fn.foundation) {
      $(document).foundation();
    }

    if (!window.gsap || !window.ScrollTrigger) {
      return;
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      return;
    }

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    gsap.registerPlugin(ScrollTrigger);

    gsap.set('.hero-actions .hero-btn', { opacity: 0, y: 18 });

    var revealBatch = function (selector, options) {
      var elements = gsap.utils.toArray(selector);
      if (!elements.length) {
        return;
      }

      gsap.from(elements, {
        y: options.y || 30,
        autoAlpha: 0,
        duration: options.duration || 0.95,
        stagger: options.stagger || 0.12,
        ease: options.ease || 'power3.out',
        scrollTrigger: {
          trigger: options.trigger || elements[0],
          start: options.start || 'top 84%',
          once: true
        }
      });
    };

    var heroTl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    heroTl
      .from('.home-hero-content .home-kicker', { y: 24, autoAlpha: 0, duration: 0.7 })
      .from('.home-hero-content h1', { y: 44, autoAlpha: 0, duration: 1.0 }, '-=0.4')
      .from('.home-hero-content p', { y: 22, autoAlpha: 0, duration: 0.7, stagger: 0.1 }, '-=0.65')
      .to('.hero-actions .hero-btn', { y: 0, opacity: 1, duration: 0.55, stagger: 0.1, clearProps: 'opacity,transform' }, '-=0.4')
      .from('.home-hero-media img', { scale: 0.92, autoAlpha: 0, duration: 1.2 }, '-=0.85');

    gsap.to('.home-hero-media img', {
      yPercent: 8,
      ease: 'none',
      scrollTrigger: {
        trigger: '.home-hero',
        start: 'top top',
        end: 'bottom top',
        scrub: 0.8
      }
    });

    revealBatch('.home-challenge .home-kicker, .home-challenge h2, .home-challenge p', {
      trigger: '.home-challenge .cell.large-5',
      y: 26,
      stagger: 0.1
    });

    revealBatch('.challenge-card li', {
      trigger: '.challenge-card',
      y: 16,
      duration: 0.6,
      stagger: 0.08
    });

    revealBatch('.home-process .home-kicker, .home-process h2', {
      trigger: '.home-process',
      y: 24,
      stagger: 0.1
    });

    revealBatch('.process-item', {
      trigger: '.process-grid',
      y: 36,
      duration: 0.8,
      stagger: 0.12
    });

    revealBatch('.home-integrated .home-kicker, .home-integrated h2, .integrated-image-wrap', {
      trigger: '.home-integrated .cell.large-6:first-child',
      y: 28,
      stagger: 0.14
    });

    revealBatch('.integrated-card', {
      trigger: '.home-integrated .cell.large-6:last-child',
      y: 24,
      duration: 0.75,
      stagger: 0.12
    });

    revealBatch('.home-contact .home-kicker, .home-contact h2', {
      trigger: '.home-contact-intro',
      y: 20,
      stagger: 0.1
    });

    revealBatch('.socigom-contact-form .wpforms-field, .socigom-contact-form .wpforms-submit-container', {
      trigger: '.socigom-contact-form',
      y: 20,
      duration: 0.7,
      stagger: 0.08
    });

    revealBatch('.site-footer .footer-brand, .site-footer p', {
      trigger: '.site-footer',
      y: 20,
      duration: 0.75,
      stagger: 0.12,
      start: 'top 92%'
    });
  });
})(jQuery);
